// extracted by mini-css-extract-plugin
export var cardIcon = "_ak-4";
export var checkboxCard = "_ak-0";
export var checkboxCardSelected = "_ak-1";
export var disabled = "_ak-2";
export var outerBorder = "_ak-3";
export var spacerMedium = "_ak-7";
export var spacerSmall = "_ak-6";
export var spacerXsmall = "_ak-5";